import { ConfigForm as form, marshal } from './ConfigForm'

const provider = {
  label: 'S3',
  form,
  marshal 
}

export default provider
